/* eslint-disable no-unused-expressions */
/* globals $ */

//
// GOOGLE
//

export function addGoogleTagManager (trackingCode) {
  (function (w, d, s, l, i) {
    w[l] = w[l] || []; w[l].push({
      'gtm.start':
        new Date().getTime(),
      event: 'gtm.js'
    })
    const f = d.getElementsByTagName(s)[0]
    const j = d.createElement(s)
    const dl = l !== 'dataLayer' ? '&l=' + l : ''
    j.async = true
    j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl
    f.parentNode.insertBefore(j, f)
  })(window, document, 'script', 'dataLayer', trackingCode)
}

export function trackForm (id, category, action, label) {
  const form = document.getElementById(id)
  form.addEventListener('submit', e => {
    e.preventDefault()

    if (!$(form).valid()) {
      return
    }

    const updatedLabel = typeof (label) === 'function' ? label() : label

    form.querySelector('[type=submit]').disabled = true
    pushEvent('form_tracking', category, action, updatedLabel)
    form.submit()
  })
}

export function trackEventFromSelector (container, selector, category, action, label) {
  container.querySelectorAll(selector).forEach((elem) =>
    trackEvent('click', elem, category, action, label)
  )
}

export function trackEvent (eventType, elem, category, action, label, isOnce = false) {
  elem.addEventListener(eventType,
    e => typeof (label) === 'function'
      ? pushEvent('custom_tracking', category, action, label(e))
      : pushEvent('custom_tracking', category, action, label),
    { once: isOnce })
}

function pushEvent (name, category, action, label) {
  if(window.dataLayer) {
    window.dataLayer.push({
      event: name,
      event_category: category,
      event_action: action,
      event_label: label
    })
  }
}
